<template>
	<card type="cinc" class="ReCardTaskEnd light mt-2">
		<template v-if="showHeader" v-slot:header><div><p>{{objTaskEnd.name}}</p></div></template>
		<div v-if="(masAllFormParams.length>0 && typeof masAllFormParams[0].elements != 'undefined' && masAllFormParams[0].elements.length>0) && (objTaskEnd.end_type!='1' && objTaskEnd.end_type!='2')">
			<!--
			<ReFormPrinterOptions v-for="(opt,index) in masAllFormParams" :key="index" :opt="opt" :frmAllConfig="masAllFormParams"/>
			-->
			<template v-if="cannotBeCompleted && cannotBeCompleted!=''"><span>{{cannotBeCompleted}}</span></template>
			<ReFormPrinter 
				:masFormConfig="masAllFormParams.masFormConfig" 
				:objSaveApiMethod="{}"
				:bInTaskEnd="true"
				:SuccessGo="SuccessGo"/>

			
		</div>
		
		<div v-else-if="objTaskEnd.end_type=='1'">
			<template v-if="fileUpload_model==''">
				<!--p>Прикрепить картинку:</p-->
				<ReFileUpload 
					v-model="fileUpload_model"
					type="file"
					:multiple="false"
					:formId="`UploadForm_${te_client_id}_${task_id}_${objTaskEnd.end_type}`"
					acceptMime="image/*"
					:bShowTrash="false"
					v-on:change="OnUploadFile"
				/>
			</template>
			<template v-else>
				<p>
					<a :href="fileUpload_model" target="_blank">Картинка прикреплена</a>
					<button class="ml-2 btn btn-icon btn-simple btn-danger" @click="DoDel()">
						<i class="tim-icons icon-trash-simple"></i>
					</button>
				</p>
			</template>
		</div>
		<div v-else-if="objTaskEnd.end_type=='2'">
			<template v-if="fileUpload_model==''">
				<!--p>Прикрепить документ:</p-->
				<ReFileUpload 
					v-model="fileUpload_model"
					type="file"
					:multiple="false"
					:formId="`UploadForm_${te_client_id}_${task_id}_${objTaskEnd.end_type}_${objTaskEnd.id}`"
					acceptMime="*/*"
					:bShowTrash="false"
					v-on:change="OnUploadFile"
				/>
			</template>
			<template v-else>
				<p>
					<a :href="fileUpload_model" target="_blank">Документ прикреплен</a>
					<button class="ml-2 btn btn-icon btn-simple btn-danger" @click="DoDel()">
						<i class="tim-icons icon-trash-simple"></i>
					</button>
				</p>
			</template>
		</div>
		<!--div v-else-if="objTaskEnd.end_type=='7'">
			<pre>{{objTaskEnd}}</pre>
		</div-->
		

		<template v-slot:footer>
			<div>
				<div v-if="strBtnWarningText!=''" class="container text-center"><div  class="badge badge-warning">{{strBtnWarningText}}<br></div></div>
				<div class="container text-center">
					<base-button :disabled="!isSaveObj || bIsSaving || isBtnDisable" class="mr-2 ml-2 run-button" @click="SaveForm()" type="success" >{{strBtnSuccessText}}</base-button>
				</div>
				<!--base-button @click="CancelForm()" type="danger" simple>Отменить</base-button-->
			</div>
		</template>
	</card>
</template>

<script>
	import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
	// import ReFormPrinterOptions from 'src/our_components/FormPrinter/ReFormPrinterOptions.vue';
	import ReFileUpload from 'src/our_components/ReFileUpload.vue';
	import {eventEmitter} from "src/plugins/globalComponents.js";

	export default {
		name: 'ReCardTaskEnd',
		components: {
			// ReFormPrinterOptions,
			ReFormPrinter,
			ReFileUpload,
		},
		props: {
			objTaskEnd: Object,
			task_id: [String, Number],
			findId: {
				type: String,
				default: '',
			},
			te_client_id: [String, Number],
			te_service_id: [String, Number],
			VER: String,
			showHeader:{
				type: Boolean,
				default: true
			}
		},
		data () {
			return {
				ver: 1,
				masAllFormParams: this.currentFormConfig(),
				bIsSaving: false,
				fileUpload_model: '',
				cannotBeCompleted: '',
			}
		},
		computed: {
			isBtnDisable(){
			    // console.log(this.masAllFormParams);
			    if(typeof this.masAllFormParams!= 'undefined' && this.masAllFormParams.apiConfig && this.masAllFormParams.apiConfig.btnDisable > ''){
				if(this.masAllFormParams.apiConfig.btnDisable == true || this.masAllFormParams.apiConfig.btnDisable == 'true'){ return true; }
			    } 
			    return false;
			},
			isSaveObj(){
				if(typeof this.masAllFormParams[0] != 'undefined'){
					if(typeof this.masAllFormParams[0].saveObj != 'undefined'){
						return true;
					}
				}
				return false;
			},
			strBtnWarningText(){
			    if(this.masAllFormParams.apiConfig && this.masAllFormParams.apiConfig.WarningText > ''){
			        return this.masAllFormParams.apiConfig.WarningText;
			    }
			    return '';
			},
			strBtnSuccessText: function(){
				//console.log(this.masAllFormParams);
				if(this.masAllFormParams.apiConfig
				&& this.masAllFormParams.apiConfig.btnText > ''){
					return this.masAllFormParams.apiConfig.btnText;
				}
				if(this.masAllFormParams[0] && this.masAllFormParams[0].apiConfig
				&& this.masAllFormParams[0].apiConfig.btnText > ''){
					return this.masAllFormParams[0].apiConfig.btnText;
				}
				/*
				if(typeof this.masAllFormParams[0] != 'undefined'){
					if(this.masAllFormParams[0].saveObj){
						if(this.masAllFormParams[0].saveObj.apiMethod != ''){
							if(this.masAllFormParams[0].saveObj.apiMethod == 'GOTO'){
								if(this.masAllFormParams[0].saveObj.apiParam.obj == 'NovoObj' || this.masAllFormParams[0].saveObj.apiParam.obj == 'SecondObj'){
									return 'Подобрать';
								}
							}
						}
					}
				}
				*/
				return 'Выполнить';
			}
		},
		watch:{
			objTaskEnd: function(val){
				this.masAllFormParams = this.currentFormConfig();
			}
		},
		methods: {
			currentFormConfig(){
				if(typeof this.objTaskEnd.FormConfig.config != 'undefined' && this.objTaskEnd.FormConfig.config.length>0){
					//let masConfRet = this.objTaskEnd.FormConfig.config;
					let masConfRet = this.$GVO.SafeParseJson(JSON.stringify(this.objTaskEnd.FormConfig.config));
					//console.log('currentFormConfig',masConfRet);
					let masFormConfig = [{collapse: true,elements: []}];
					let masReq = [];
					let masNotReq = [];
					let iHiddenCntReq = 0;
					let iHiddenCntNotReq = 0;
					if(masConfRet.length>0){
						for (let i = 0; i < masConfRet.length; i++) {
							if(typeof masConfRet[i] !== 'undefined' && masConfRet[i].elements.length > 0){
								for (let x = 0; x < masConfRet[i].elements.length; x++) {
									const element = masConfRet[i].elements;
									//console.log(element[x]);
									if((masConfRet[i].elements[x].required===true && masConfRet[i].elements[x].elementType!='label') || masConfRet[i].elements[x].elementGetParamMap == "FlatList"){  //костыль с FlatList для перехода в модуль подбора и отправки презентаций
										masReq.push(masConfRet[i].elements[x]);
										if(masConfRet[i].elements[x].elementType=="input-hidden")iHiddenCntReq++;
									}else{
										masNotReq.push(masConfRet[i].elements[x]);
										if(masConfRet[i].elements[x].elementType=="input-hidden")iHiddenCntNotReq++;
									}
								}
							}
						}
						if (masReq.length > 0) {
							masFormConfig.push({blockTitle: 'Обязательные',elements: [], bHideTab:(iHiddenCntReq==masReq.length)});
							masFormConfig[masFormConfig.length-1].elements = masReq;
						}
						if (masNotReq.length > 0) {
							masFormConfig.push({blockTitle: 'Не обязательные',elements: [], bHideTab:(iHiddenCntNotReq==masNotReq.length)});
							//console.log(this.$GVO.unlinkObject(masFormConfig));
							masFormConfig[masFormConfig.length-1].elements = masNotReq;
						}
						//console.log(masFormConfig);
					}
					masConfRet['masFormConfig'] = masFormConfig;
					//*
					if(this.objTaskEnd.FormConfig.data.apiConfig)
						masConfRet.apiConfig = this.objTaskEnd.FormConfig.data.apiConfig;
					//*/
					//console.log('masConfRet',masConfRet)
					return masConfRet;
				}
				return [];
			},
			SaveForm(){
				// console.log('SaveForm',this.masAllFormParams);
				if(this.masAllFormParams[0].saveObj){
					if(this.masAllFormParams[0].saveObj.apiMethod != '' && !this.$GVO.isEmpty(this.masAllFormParams[0].saveObj.apiParam)){
						this.bIsSaving=true;
						let objRet = {};
						for (let i = 0; i < this.masAllFormParams.length; i++) {
							if(typeof this.masAllFormParams[i].elements == 'undefined') continue;
							for (let iEl = 0; iEl < this.masAllFormParams[i].elements.length; iEl++) {
								if(typeof this.masAllFormParams[i].elements[iEl].elementGetParamMap != 'undefined' && this.masAllFormParams[0].checklist !== true){
									const key = this.masAllFormParams[i].elements[iEl].elementGetParamMap;
									if (!this.CheckRequired(this.masAllFormParams[i].elements[iEl])) {
										this.bIsSaving=false;
										return false;
									}
									if(!this.$GVO.isEmpty(this.masAllFormParams[i].elements[iEl].element_model)){
										if(this.masAllFormParams[i].elements[iEl].elementType == 'input-contact'){
											if(typeof this.objSaveApiMethodDataParam != 'undefined' && this.objSaveApiMethodDataParam != ''){
												if(typeof objRet[this.objSaveApiMethodDataParam] == 'undefined'){
													objRet[this.objSaveApiMethodDataParam] = [];
												}
											}else{
												if(typeof objRet[this.masAllFormParams[i].elements[iEl].elementGetParamMap] == 'undefined'){
													objRet[this.masAllFormParams[i].elements[iEl].elementGetParamMap] = [];
												}
											}
											for (let ind = 0; ind < this.masAllFormParams[i].elements[iEl].element_model.length; ind++) {
												if(this.masAllFormParams[i].elements[iEl].element_model[ind].contact_value != '' && this.masAllFormParams[i].elements[iEl].element_model[ind].contact_type != ''){
													if(this.masAllFormParams[i].elements[iEl].element_model[ind].contact_id == ''){
														this.masAllFormParams[i].elements[iEl].element_model[ind].contact_id = 0;
													}
													if(this.masAllFormParams[i].elements[iEl].element_model[ind].contact_view == ''){
														this.masAllFormParams[i].elements[iEl].element_model[ind].contact_view = 0;
													}
													if(typeof this.objSaveApiMethodDataParam != 'undefined' && this.objSaveApiMethodDataParam != ''){
														objRet[this.objSaveApiMethodDataParam].push(this.masAllFormParams[i].elements[iEl].element_model[ind]);
													}else{
														objRet[this.masAllFormParams[i].elements[iEl].elementGetParamMap].push(this.masAllFormParams[i].elements[iEl].element_model[ind]);
													}
												}
											}
										}else if(this.masAllFormParams[i].elements[iEl].elementType == 'input-ajaxsearch-distrmetro'){
											objRet['district_ids'] = '';
											//objRet['direction_ids'] = [];
											objRet['metro_ids'] = '';
											//objRet['map_area'] = '';
											if(this.masAllFormParams[i].elements[iEl].element_model.district_ids.value.length>0){
												objRet['district_ids'] = this.masAllFormParams[i].elements[iEl].element_model.district_ids.value;
											}
											/*
											if(this.masAllFormParams[i].elements[iEl].element_model.directions.all.length>0){
												objRet['direction_ids'] = this.masAllFormParams[i].elements[iEl].element_model.directions.all;
											}
											*/
											if(this.masAllFormParams[i].elements[iEl].element_model.metro_ids.value.length>0){
												objRet['metro_ids'] = this.masAllFormParams[i].elements[iEl].element_model.metro_ids.value;
											}
											/*
											if(this.masAllFormParams[i].elements[iEl].element_model.map.all.length>0){
												objRet['map_area'] = this.masAllFormParams[i].elements[iEl].element_model.map.all;
											}
											*/
										}else if((this.masAllFormParams[i].elements[iEl].elementGetParamMap == 'district_ids' || this.masAllFormParams[i].elements[iEl].elementGetParamMap == 'direction_ids' || this.masAllFormParams[i].elements[iEl].elementGetParamMap == 'metro_ids' || this.masAllFormParams[i].elements[iEl].elementGetParamMap == 'map_area') && this.masAllFormParams[i].elements[iEl].elementType=='hidden-input'){
											// не обрабатываем, тупо заглушка
										}else if(this.masAllFormParams[i].elements[iEl].elementType == 'input-amount'){
											objRet[this.masAllFormParams[i].elements[iEl].elementGetParamMap] = this.$GVO.str_replace(' ','',this.masAllFormParams[i].elements[iEl].element_model);
										}else if(this.masAllFormParams[i].elements[iEl].elementType == 'input-date-range' || this.masAllFormParams[i].elements[iEl].elementType == 'input-time-range' || this.masAllFormParams[i].elements[iEl].elementType == 'input-range'){
											const masDtKeys = key.split('|');

											if(this.masAllFormParams[i].elements[iEl].element_model.startDt != ''){
												objRet[masDtKeys[0]] = this.masAllFormParams[i].elements[iEl].element_model.startDt;
											}
											if(this.masAllFormParams[i].elements[iEl].element_model.endDt != ''){
												objRet[masDtKeys[1]] = this.masAllFormParams[i].elements[iEl].element_model.endDt;
											}
											if(typeof this.masAllFormParams[i].elements[iEl].element_model.min !='undefined' && this.masAllFormParams[i].elements[iEl].element_model.min != ''){
												objRet[masDtKeys[0]] = this.masAllFormParams[i].elements[iEl].element_model.min;
											}
											if(typeof this.masAllFormParams[i].elements[iEl].element_model.max !='undefined' && this.masAllFormParams[i].elements[iEl].element_model.max != ''){
												objRet[masDtKeys[1]] = this.masAllFormParams[i].elements[iEl].element_model.max;
											}

										}
										// else if(this.masAllFormParams[i].elements[iEl].elementGetParamMap == 'offers'){
										// 	// objRet[this.masAllFormParams[i].elements[iEl].elementGetParamMap] = this.masAllFormParams[i].elements[iEl].element_model;
										// 	this.cannotBeCompleted = 'Задача не может быть выполнена из-за отсутствия оферт';
										// 	console.log('this is offers without options');
										// 	// this.$GVO.showAlert('offers поле','this is offers without options');
										// } 
										else{
											objRet[this.masAllFormParams[i].elements[iEl].elementGetParamMap] = this.masAllFormParams[i].elements[iEl].element_model;
										}
									}
								}else if(this.masAllFormParams[0].checklist === true){
									if(typeof this.masAllFormParams[i].elements[iEl].checklist != 'undefined'){
										if(typeof objRet[this.masAllFormParams[i].elements[iEl].elementGetParamMap] == 'undefined'){
											objRet[this.masAllFormParams[i].elements[iEl].elementGetParamMap] = [];
										}
										let ret = 0;
										if(this.masAllFormParams[i].elements[iEl].checklist.element_model === true && this.masAllFormParams[i].elements[iEl].required == true){ ret = 3;}
										else if(this.masAllFormParams[i].elements[iEl].checklist.element_model === true){ ret = 1;}
										else if(this.masAllFormParams[i].elements[iEl].checklist.element_model === false && this.masAllFormParams[i].elements[iEl].required == true){ ret = 2;}
										objRet[this.masAllFormParams[i].elements[iEl].elementGetParamMap]=ret;
									}
								}
							}
						}


						if(typeof this.masAllFormParams[0].saveObj.apiParam.uData.submit_btn_ok != "undefined"){
							this.masAllFormParams[0].saveObj.apiParam.uData.submit_btn_ok = 1;
						}else if((this.objTaskEnd.end_type=='1' || this.objTaskEnd.end_type=='2') && this.fileUpload_model != ''){
							this.masAllFormParams[0].saveObj.apiParam.uData = {file_link:this.fileUpload_model};
						}else{
							this.masAllFormParams[0].saveObj.apiParam.uData = objRet;
						}
						//Заполнение параметров фильтра для АПИ запроса
						this.masAllFormParams[0].saveObj.apiParam.flt.taskend_id = this.objTaskEnd.id;
						let client_id = '-1';
						if(typeof this.$route.params.client_id != 'undefined'){
							client_id = this.$route.params.client_id;
						}
						if(typeof this.te_client_id != 'undefined'){
							client_id = this.te_client_id;
						}
						this.client_id=client_id;
						
						this.masAllFormParams[0].saveObj.apiParam.flt.client_id = client_id;
						this.masAllFormParams[0].saveObj.apiParam.flt.id = this.task_id;
						
						// console.log('данные для отправки формы',this.masAllFormParams[0].saveObj.apiParam);
						//return true;
						if(this.masAllFormParams[0].saveObj.apiMethod != 'GOTO'){
							this.masAllFormParams[0].saveObj.apiParam.uData = {...this.masAllFormParams[0].saveObj.apiParam.uData,...{'VER':this.VER}};
							// console.log(this.masAllFormParams[0].saveObj.apiMethod);
							this.$GVO.ApiCall(this.masAllFormParams[0].saveObj.apiMethod,this.masAllFormParams[0].saveObj.apiParam)
							.then((objApi) => {
								// console.log('Пришли данные от АПИ',objApi);
								this.bIsSaving=false;
								if(objApi.success === true){
									if(typeof objApi.RUN_TASK_VER != 'undefined'){
										if(parseInt(objApi.RUN_TASK_VER) > this.$GVO.RUN_TASK_VER){
											//console.log(this.masAllFormParams[0].saveObj.apiMethod,'reload_tasks');
											this.$GVO.RUN_TASK_VER = parseInt(objApi.RUN_TASK_VER);
											eventEmitter.$emit('reload_tasks',objApi);
											this.$emit('taskfinished');
										}
									}else{
										//console.log(this.masAllFormParams[0].saveObj.apiMethod,'reload_tasks');
										this.$GVO.RUN_TASK_VER = -1;
										eventEmitter.$emit('reload_tasks',objApi);
										this.$emit('taskfinished');
									}
									// location.reload();
								}else{
									if(objApi.ClientMsg.msg && objApi.ClientMsg.msg !=''){
										// console.log('непонятная зверушка');
									}
									else if(objApi.msg.indexOf('["uData"]["file_link"]')!=-1){
										this.bIsSaving=false;
										this.$GVO.showAlert('Обязательное поле','Необходимо загрузить картинку или документ');
										return false;
									} 
								}
							}).catch(errorObjApi => {console.error(errorObjApi);this.bIsSaving=false;});
						}else{
							//*
							if(this.masAllFormParams.apiConfig
							&& this.masAllFormParams.apiConfig.btnLink > ''){
								const me=this;
								if(me.objTaskEnd && typeof me.objTaskEnd.JSON_PARAM){
									try{
										me.objTaskEnd.JSON_PARAM = JSON.parse(me.objTaskEnd.JSON_PARAM)
									}catch(e){}
								}
								const link=this.masAllFormParams.apiConfig.btnLink.replace(/\${([^\}]+)}/g,(match,paramsStr)=>{
									let cur=me;
									const params=paramsStr.split('.');
									let v;
									while(cur !== undefined && params.length>0){
										v=params.shift();
										cur=cur[v];
									}
									return cur;
								})
								this.$router.push({path:link});
							}else{
							/*
								if(this.masAllFormParams[0].saveObj.apiParam.obj == 'NovoObj'){
									this.$router.push({path: `/data/module/sso?task_id=${this.task_id}&taskend_id=${this.objTaskEnd.id}&client_id=${client_id}&service_id=${this.te_service_id}&dSearchType=complex&dSortType=actual&dSortOrder=a&AddComplexMinFlatsBig=1&dnotworkgk=0`});
								}
								if(this.masAllFormParams[0].saveObj.apiParam.obj == 'SecondObj'){
									this.$router.push({path: `/data/module/sso?task_id=${this.task_id}&taskend_id=${this.objTaskEnd.id}&client_id=${client_id}&service_id=${this.te_service_id}&dSearchType=flats&dSortType=dt_upd|d&dSortOrder=d`});
								}
								*/
							}
							this.bIsSaving=false;
						}
					}
				}
			},
			CancelForm(){
				location.reload();
			},
			CheckRequired(el){ //return true;
				if (typeof el.auto_hidden != 'undefined' && typeof el.auto_show != 'undefined') 
					if (el.auto_hidden == true && !el.auto_show) return true; //костыль для АВТО скрытых полей
				if (typeof el.auto_hidden != 'undefined') 
					if (el.auto_hidden == true) return true; //костыль для АВТО скрытых полей
					
				if (el.elementType == 'input-hidden') return true; //костыль для скрытых инпутов
				if (el.elementType.indexOf('check') != -1) return true; // костыль для чекбоксов
				
				let f_label = '';
				if(typeof el.label != 'undefined' && el.label != '') {
					f_label = el.label;
				} else if(typeof el.placeholder != 'undefined' && el.placeholder != ''){
					f_label = el.placeholder;
				}
				// console.log(el);
				if (el.required && (el.element_model == '' || this.$GVO.isEmpty(el.element_model))) {
					if(typeof el.ignore_required_check != 'undefined' && el.ignore_required_check==true) return true;
					this.$GVO.showAlert('Обязательное поле','Необходимо заполнить обязательное поле: '+f_label);
					return false;
				}else if(el.elementType == 'input-contact'){
					if(el.required && el.element_model.length > 0){
						if(el.element_model[0].contact_value == '' && el.element_model[0].contact_group=='phone'){
							this.$GVO.showAlert('Обязательное поле','Необходимо заполнить обязательное поле: '+f_label);
							return false;
						}
					}
				}else if(el.elementType == 'ajax-list'){
					if(el.required && (typeof el.element_model.selectedVal == 'undefined' || el.element_model.selectedVal == '')){
						this.$GVO.showAlert('Обязательное поле','Необходимо заполнить обязательное поле: '+f_label);
						return false;
					}
				}else if(el.elementType == 'passport-upload'){
					if(el.required && (typeof el.state.isFiles == 'undefined' || el.state.isFiles == false)){
						this.$GVO.showAlert('Обязательное поле','Необходимо заполнить обязательное поле: '+f_label);
						return false;
					}
				}
				else if(el.elementType == 'list-of-people'){
					//console.log(el.element_model);
					for (let p = 0; p < el.element_model.length; p++) {
						//console.log(el.element_model[p].passport_files);
						if(el.element_model[p].passport_files.length == 0){
							this.$GVO.showAlert('Обязательное поле','Необходимо заполнить обязательное поле: '+f_label+' Паспорт');
							return false;
						}
						/*
						//console.log(el.element_model[p].inn_files);
						if(el.element_model[p].inn_files.length == 0){
							this.$GVO.showAlert('Обязательное поле','Необходимо заполнить обязательное поле: '+f_label+' ИНН');
							return false;
						}
						*/
						if(el.element_model[p].inn == ''){
							this.$GVO.showAlert('Обязательное поле','Необходимо заполнить обязательное поле: '+f_label+' ИНН');
							return false;
						}
						//console.log(el.element_model[p].snils_files);
						if(el.element_model[p].snils_files.length == 0){
							this.$GVO.showAlert('Обязательное поле','Необходимо заполнить обязательное поле: '+f_label+' СНИЛС');
							return false;
						}
					}
				}else if((this.objTaskEnd.end_type=='1' || this.objTaskEnd.end_type=='2') && this.fileUpload_model == ''){
					this.$GVO.showAlert('Обязательное поле','Необходимо загрузить картинку или документ');
					return false;
				}
				// else if(el.elementType == 'checkbox-group' && el.options.length == 0){
				// 	this.$GVO.showAlert('Обязательное поле','Нет опций для выполнения задачи');
				// 	return false;
				// }
				return true;
			},
			DoDel(){
				/*
				//console.log('DoDel',this.value[objIndex].id);
				this.$GVO.ApiCall('DEL_TASK_HELP',{obj:'BP',flt:{id:this.value[objIndex].id} })
					.then((objApi) => {
						if(objApi.success === true){
							//console.log(objApi);
							this.value.splice(objIndex, 1);
						}
					}).catch(errorObjApi => console.log(errorObjApi));
				*/
				this.fileUpload_model = '';
			},
			OnUploadFile(objData){
				//console.log('OnUploadFile', objData);
				//this.objTaskEnd.end_type=='1' || this.objTaskEnd.end_type=='2'
				this.bUploading=true;
				let objSendApi = {obj:'FileUpload',flt:{type:'taskend_photo'}};
				if(this.objTaskEnd.end_type=='2'){
					objSendApi = {obj:'FileUpload',flt:{type:'taskend_file'}};
				}
				this.$GVO.UploadFile(objData.formId,'UniUpload',objSendApi)
					.then(objApi => {  
						//console.log(objApi);
						if(objApi.success){
							this.fileUpload_model = objApi.data.fullpath;
						}else{
							alert(objApi.msg);
						}
						this.bUploading=false;
					})
					.catch(errorObjApi => 	{  console.error(errorObjApi); this.bUploading=false;});
			},
			SuccessGo(ret){
				// console.log(ret);
				// this.$emit('taskfinished'); // чтобы переотрисовывать табы в задачах
				
			},
		},
	}
</script>
<style>
	.run-button{
		min-width:160px;
	}
	.ReCardTaskEnd .card-footer{
		display:flex;
		justify-content: space-around;
		padding-top: 0px;
	}
	.ReCardTaskEnd .card-body {padding-top: 0px;}
	.ReCardTaskEnd .card-collapse .card:not(.card-cinc) .card-body {padding: 0;}
	.ReCardTaskEnd .form-options-group{width: 100%;}
	.white-content .card:not(.card-white) .light {background: transparent; box-shadow: none!important; webkit-box-shadow: none!important;}
	p.description > a{cursor: pointer;}
	p.description > a > i{margin-right: 10px;}
	.ReCardTaskEnd .card-collapse .card:not(.card-cinc) .card-header a {color: rgb(1, 176, 224);}
	.ReCardTaskEnd .card-collapse {border-right: 0px!important;}
	.ReCardTaskEnd {
		border: 1px solid rgba(1, 176, 224, 0.4);
		padding: 0px 10px;
	}
	/* .ReCardTaskEnd:not(:first-child) {
		border-top: 2px solid #01B0E0;    
		border-radius: 0;
	} */
		
</style>

